export default "__VITE_ASSET__G49beKnv__"